"use client"
import styled from "@emotion/styled"
import { Button } from "@mui/material"
import { useLocale, useTranslations } from "next-intl"
import { Container, NewText, ShareIcon } from "ui"
import { sharedColors } from "ui/theme/colors"
import { extractProperty } from "utils/extractProperty"

const StyledBreadContainer = styled.div`
  padding-top: 32px;
  padding-bottom: 32px;
  ${(props) => props.theme.breakpoints.up("md")} {
    padding-top: 40px;
    padding-bottom: 40px;
  }
`
const StyledMetaContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 24px;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  border-top: 2px solid #f7f7f7;
  border-bottom: 2px solid #f7f7f7;
  height: 72px;
  ${(props) => props.theme.breakpoints.up("md")} {
  }
`
const StyledBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-width: 800px;
  width: 100%;
  ${(props) => props.theme.breakpoints.up("md")} {
    gap: 16px;
    width: 800px;
  }
`
const StyledMainHeader = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: center;
  flex-direction: column;
`
export const ArticleHeader: React.FC = ({ data, children }: any) => {
  const articleMainTitle = extractProperty(data, "articleMainTitle")
  const activitySubTitle = extractProperty(data, "activitySubTitle")
  const articleDate = extractProperty(data, "articleDate")
  const date = new Date(articleDate)
  const yyyy = date.getFullYear()
  const mm = date.getMonth() + 1
  const dd = date.getDate()
  const locale = useLocale()
  const t = useTranslations("Job")

  const formattedDate = dd + "." + mm + "." + yyyy

  const onShare = async () => {
    const shareData = {
      title: articleMainTitle,
      url: window.location.href,
    }
    if (navigator.share && navigator.canShare(shareData)) {
      try {
        await navigator.share(shareData)
      } catch (err) {
        console.error(err)
      }
    } else {
      navigator.clipboard.writeText(shareData.url)
    }
  }

  return (
    <Container>
      <StyledBreadContainer>{children}</StyledBreadContainer>
      <StyledMainHeader>
        <StyledBox>
          <NewText
            desktopFontSize={40}
            desktopFontWeight="400"
            desktopLineHeight="44px"
            mobileFontSize={32}
            mobileFontWeight="400"
            mobileLineHeight="46px"
            component="h1"
            color={sharedColors.black}
          >
            {articleMainTitle}
          </NewText>
          <NewText
            desktopFontSize={18}
            desktopFontWeight="400"
            desktopLineHeight="26px"
            mobileFontSize={16}
            mobileFontWeight="400"
            mobileLineHeight="23px"
            component="h2"
            color={sharedColors.black}
          >
            {activitySubTitle}
          </NewText>
          <StyledMetaContainer>
            <NewText
              desktopFontSize={16}
              desktopFontWeight="400"
              desktopLineHeight="23.04px"
              mobileFontSize={14}
              mobileFontWeight="400"
              mobileLineHeight="20px"
              component="p"
              color={"#6F6F6F"}
            >
              {locale === "he" ? ` פורסם בתאריך: ${formattedDate}` : `Posted on: ${formattedDate}`}
            </NewText>
            <Button
              aria-label={t("shareSocial")}
              variant="text"
              startIcon={<ShareIcon />}
              onClick={onShare}
            ></Button>
          </StyledMetaContainer>
        </StyledBox>
      </StyledMainHeader>
    </Container>
  )
}

export default ArticleHeader
